import useACL from 'hooks/useACL'
import React from 'react'

// eslint-disable-next-line react/prop-types
function ACL({ allow = [], deny, children, ...rest }) {
  const hasAccess = useACL(deny || allow, {
    mode: deny ? 'deny' : 'allow',
  })

  if (allow?.length && deny) {
    throw new Error('ACL: You can only use one of allow or deny')
  }

  if (!hasAccess) {
    return null
  }

  if (!children) {
    return null
  }

  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, rest)
    }
    return child
  })

  return childrenWithProps
}

export default ACL
